import React from 'react';
import logo from '../logo.svg';

export default function NavBar({ onMenu, showBack, onBack, onGoAdd, onHelp }) {
  return (
    <nav className="flique-topbar">
      <div className="container d-flex align-items-center justify-content-between gap-2">
        <a
          href="#add"
          className="flique-topbar-logo-link"
          onClick={(e) => {
            e.preventDefault();
            onGoAdd?.();
          }}
          aria-label="Add a movie"
        >
          <img src={logo} alt="" className="flique-topbar-logo" />
        </a>
        <div className="d-flex align-items-center gap-2">
          {!showBack && (
            <button
              type="button"
              className="btn flique-settings flique-help-icon-btn"
              aria-label="Help"
              onClick={onHelp}
            >
              <span className="flique-help-icon" aria-hidden="true">?</span>
            </button>
          )}
          <button
            type="button"
            className="btn flique-settings"
            aria-label={showBack ? 'Back' : 'Settings'}
            onClick={showBack ? onBack : onMenu}
          >
            {showBack ? (
              <span className="flique-topbar-back-label">Back</span>
            ) : (
              <svg
                className="flique-settings-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <circle cx="12" cy="12" r="3" />
                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
              </svg>
            )}
          </button>
        </div>
      </div>
    </nav>
  );
}

